import { Button, Box } from '@mui/material'
import React from 'react'

type Props = {
  onReturnUserPress: () => void
  onNewUserPress: () => void
}

const OnboardingWelcome = (props: Props) => {
  const {
    onReturnUserPress,
    onNewUserPress
  } = props;
  return (
    <Box display="flex" flexDirection="column" alignItems="center" gap={3}>
      <Button
        variant="contained"
        onClick={onReturnUserPress}
        fullWidth
      >
        Returning User
      </Button>
      <Button
        variant="outlined"
        onClick={onNewUserPress}
        fullWidth
      >
        New User
      </Button>
    </Box>
  )
}

export default OnboardingWelcome